import React, {Component} from 'react';


class System extends Component {

    constructor(props) {
        super(props);

        this.state = {
            partiJsonText: window.localStorage.getItem('dkk-proeve-parti-' + process.env.REACT_APP_ENV),
            eventsJsonText: window.localStorage.getItem('dkk-proeve-lydighet-parti-events-' + process.env.REACT_APP_ENV)
        }
    }



    render() {
        const {partiJsonText, eventsJsonText} = this.state;
        return (
            <div className="container">
                <div><strong>Partidata</strong></div>
                <div>
                    {partiJsonText}
                </div>
                <div><strong>Eventdata</strong></div>
                <div>
                    {eventsJsonText}
                </div>
            </div>
        );
    }
}
export default System;





// WEBPACK FOOTER //
// ./src/pages/system/System.js